import { render, staticRenderFns } from "./organization-contracts-card.vue?vue&type=template&id=238b712a"
import script from "./organization-contracts-card.vue?vue&type=script&lang=js"
export * from "./organization-contracts-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports